<script setup lang="ts">
import { computed } from 'vue'

import type { ParticipantSubType } from '@collector/sportsapi-client-legacy'

import type { LineupConfig } from '../../interfaces/LineupConfig'
import type { LineupModel } from '../../interfaces/LineupModel'
import AddToPositionButton from './AddToPositionButton.vue'

type Props = {
  type: 'new' | 'found' | 'squad'
  config: LineupConfig
  lineup: LineupModel
  disabled?: boolean
  disabledReasonText?: string
  shirtNr?: string | null
  subType?: ParticipantSubType | null
  shouldRenderButton?: (
    subType: ParticipantSubType | null | undefined,
    name: string,
  ) => boolean
}
const props = defineProps<Props>()

type Emits = {
  add: [positionKey: PropertyKey]
}
const emit = defineEmits<Emits>()

//computed
const positionEntries = computed(() =>
  Object.entries(props.config.positions).filter(
    ([_, config]) => !config.deleteOnly,
  ),
)
</script>

<template>
  <template v-for="[name, positionConfig] in positionEntries">
    <AddToPositionButton
      v-if="!shouldRenderButton || shouldRenderButton(subType, name)"
      :key="name"
      :config="positionConfig"
      :lineup
      :name
      :type
      :shirtNr
      :subType
      :disabled
      :disabledReasonText
      @add="emit('add', name)"
    />
  </template>
</template>
